import React from "react";
import CircularGraph from "../../components/D3/CircularGraph/CircularGraph";
import Circle from "./config/images/circle.svg";

const ProgressHeader = ({data, setToggleRow, toggleRow}) => {
  const rootStyles = getComputedStyle(document.documentElement);
  const grey = rootStyles.getPropertyValue('--grey').trim();
  const green = rootStyles.getPropertyValue('--green').trim();
  const red = rootStyles.getPropertyValue('--red').trim();
  const orange = rootStyles.getPropertyValue('--orange').trim();
  const yellow = rootStyles.getPropertyValue('--dark-yellow').trim();

  const calculateColor = (value) => {
    return  value <= .25 ? red : value > .25 && value <= .50 ? orange : value > .50 && value <= .75 ? yellow : green
  }

  return (
    <div className={"progress-row"}>
      <span className={`expand-btn ${toggleRow}`} onClick={(e) => {
        e.stopPropagation();
        setToggleRow(!toggleRow)
      }}>{toggleRow ? '+' : '-'}</span>
      <p className={`circle-graph-title sub-title ${toggleRow}`}>Progress</p>
      <div className={"circle-container"} style={{backgroundImage: `url(${Circle}`}}>
        <CircularGraph
          innerRadius={33}
          outerRadius={35}
          xAxis={3}
          height={100}
          width={100}
          containerName={'maturity-assessment-progress'}
          data={data}
          color={toggleRow ? grey : calculateColor(data.value)}
        />
      </div>
    </div>
  )
}

export default ProgressHeader